import React from 'react';
import '../assets/styles/App.css';
import { Container} from 'semantic-ui-react'
import Myprofile from './Myprofile.js'
import MainContent from './MainContent.js'
import LabelTag from './LabelTag.js'
import { connect } from 'react-redux'
import {switchLanguageEn, switchLanguageTw} from '../actions'

const App = ({myMultiLang, switchLanguageEn, switchLanguageTw}) => (
      <div className="App">
        <div className="multiLang">

          {myMultiLang.lang==='en' &&
            <div><a className='active'>English</a>
            <a onClick={switchLanguageTw} >繁體中文</a></div>
          }
          {myMultiLang.lang==='tw' &&
            <div>
              <a onClick={switchLanguageEn} >English</a>
              <a className='active' >繁體中文</a>
            </div>
          }

        </div>
        <header className="App-header">
          <h1 className="App-title">{myMultiLang.welcome_title}</h1>
          <LabelTag {...myMultiLang}/>
        </header>
        <Container>
          <Myprofile {...myMultiLang}/>
          <MainContent {...myMultiLang}/>
        </Container>
      </div>
)

const mapStateToProps = (state) => {
  return {
    myMultiLang: state.multiLangReducers
  }
}

const mapDispatchToProps = (dispatch) =>{
  return {
    switchLanguageEn: (lang)=>{
      dispatch(switchLanguageEn(lang))
    },
    switchLanguageTw: (lang)=>{
      dispatch(switchLanguageTw(lang))
    },
  }
}

const myAppComp = connect(
  mapStateToProps,
  mapDispatchToProps
)(App)

export default myAppComp


// WEBPACK FOOTER //
// ./src/components/App.js